// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"ButtonGroup_ButtonGroup_37qyJ","item":"ButtonGroup_item_2ZZ68","segmented":"ButtonGroup_segmented_1jgTx","fill":"ButtonGroup_fill_398sc"};